import _ from 'lodash'

export const zipPublicAndPrivateKeys = (publicKeys, privateKeys) => {
  return privateKeys
    .map((privateKey) => {
      const { secretId, secretValue: privateKeyValue } = privateKey

      // Add safety check for secretId
      if (!secretId || typeof secretId !== 'string') {
        return null
      }

      const accountIdExists = secretId.split('--').length >= 3
      const accountId = accountIdExists ? _.chain(secretId).split('--').last().value() : ''
      const publicKey = publicKeys.find(({ keyId }) => {
        const keyIdIndex = keyId.indexOf('--')
        const secretIdIndex = secretId.indexOf('--')
        if (keyIdIndex === -1 || secretIdIndex === -1) return false
        const keyIdSubstr = keyId.substring(keyIdIndex + 2)
        const secretIdSubstr = secretId.substring(secretIdIndex + 2)
        return keyIdSubstr === secretIdSubstr
      })
      const publicKeyValue = publicKey?.keyValue || ''
      return { keyId: secretId, accountId, publicKey: publicKeyValue, privateKey: privateKeyValue }
    })
    .filter(Boolean) // Remove null entries
}

/**
 * Generate a random connector key with specified number of characters containing only letters and numbers
 * @param {number} digits - The number of characters in the connector key
 * @returns {string} A alphanumeric string with specified number of characters
 */
export const generateConnectorKey = (digits = 32) => {
  const alphanumericChars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
  let key = ''
  for (let i = 0; i < digits; i++) {
    key += alphanumericChars[Math.floor(Math.random() * alphanumericChars.length)]
  }
  return key
}